export default "__VITE_ASSET__eb514bc1__"